// C:\xampp\htdocs\sait\client\src\components\MobileBottomNav.js

import React, { useContext, useState } from 'react';
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../../../../index";
import {
    ADD_ROUTE,
    FAVOURITES_ROUTE,
    MAIN_ROUTE,
    PLACES_ROUTE,
    PROFILE_ROUTE,
    BLOG_ROUTE,
    ABOUT_US_ROUTE,
    SHOP_ROUTE,
    PHOTO_GALLERY_ROUTE
} from "../../../../utils/consts";
import RegistrationForm from "../../../modals/UserForms/RegistrationForm/RegistrationForm";
import ExploreMenu from "../ExploreMenu/ExploreMenu";

import Dom from "../../../../Assets/BottomMenu/Дом.png";
import Poisk from "../../../../Assets/BottomMenu/Поиск.png";
import Appartments from "../../../../Assets/BottomMenu/Appartments.svg";
import Favourites from "../../../../Assets/hearts/heart-gray.svg";
import profilePlaceholder from "../../../../Assets/profile.svg";

import styles from './MobileBottomNav.module.css';
import ym from "react-yandex-metrika"; // <-- ИЗМЕНЕНО: ИМПОРТ CSS-МОДУЛЕЙ

const MobileBottomNav = observer(() => {
    const { user } = useContext(Context);
    const history = useHistory();
    const location = useLocation(); // Объект location для получения текущего пути

    // Состояния для управления видимостью модальных окон/меню
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [showExploreMenu, setShowExploreMenu] = useState(false);

    // Функция для получения URL изображения профиля пользователя
    const getProfileImageUrl = () => {
        if (!user.UserData || !user.UserData.id) {
            return profilePlaceholder; // Изображение-заглушка, если данных нет
        }

        const userId = user.UserData.id;
        const userImg = user.UserData.img;

        if (userImg === 'EMPTY' || !userImg) {
            return profilePlaceholder;
        } else if (typeof userImg === 'string') {
            const constructedPath = `users/user${userId}/${userImg}`;
            const fullImageUrl = process.env.REACT_APP_API_URL + constructedPath;
            return fullImageUrl;
        } else {
            return profilePlaceholder;
        }
    };

    // Обработчик клика для элемента "Профиль"
    const handleProfileClick = () => {

        console.log('Отправляю событие в метрику...');

        if (user.isAuth && user.UserData?.id) {
            // Если пользователь авторизован, перенаправляем в его профиль
            history.push(`${PROFILE_ROUTE}/${user.UserData.id}`);
            ym('reachGoal','history.push(`${PROFILE_ROUTE} NAVIGATION`)')
        } else {
            // Если не авторизован, перенаправляем на страницу авторизации
            setShowRegistrationModal(true);
        }
    };

    // Обработчик клика для элемента "Избранное"
    const handleFavouritesClick = () => {
        if (user.isAuth) {
            // Если пользователь авторизован, перенаправляем на страницу избранного
            history.push(FAVOURITES_ROUTE);
            ym('reachGoal','history.push(FAVOURITES_ROUTE) NAVIGATION')
        } else {
            // Если не авторизован, показываем модальное окно авторизации
            setShowRegistrationModal(true);
        }
    };

    // Обработчик клика для элемента "Исследовать" (открытие/закрытие меню)
    const handleExploreClick = () => {
        setShowExploreMenu(prev => !prev);
    };

    // Обработчик закрытия меню "Исследовать" (используется для клика вне)
    const handleCloseExploreMenu = () => {
        setShowExploreMenu(false);
    };

    // Определение элементов навигации в нижней панели
    // Каждый элемент имеет 'label' (текст), 'icon', 'route' (маршрут) и 'type' ('link' или 'button')
    const navItems = [
        { label: 'Главная', icon: Dom, route: MAIN_ROUTE, type: 'link' }, // Ведет на /main
        { label: 'Жилье', icon: Appartments, route: ADD_ROUTE, type: 'link' }, // Ведет на /add
        { label: 'Избранное', icon: Favourites, type: 'button' }, // Специальная кнопка
        { label: 'Исследовать', icon: Poisk, type: 'button' }, // Специальная кнопка
        { label: 'Профиль', icon: profilePlaceholder, type: 'button' }, // Специальная кнопка
    ];

    return (
        <>
            {/* Нижняя навигационная панель, видимая только на мобильных устройствах */}
            <nav className={`${styles.mobileBottomNav} ${styles.mobileBottomNavHideOnDesktop}`}>
                {/* Итерация по элементам навигации для их отображения */}
                {navItems.map((item, index) => {
                    let iconSrc = item.icon; // Иконка по умолчанию
                    let isActiveItem = false; // Флаг, который определяет, активен ли текущий элемент

                    // Если элемент - "Профиль", используем изображение профиля пользователя
                    if (item.label === 'Профиль') {
                        iconSrc = getProfileImageUrl();
                    }

                    // --- Логика определения активности для каждого элемента навигации ---
                    if (item.type === 'link') {
                        // Логика для элементов типа 'link' (Главная, Жилье)
                        if (item.route === MAIN_ROUTE) {
                            // "Главная" активна только если текущий путь точно равен MAIN_ROUTE (/main)
                            isActiveItem = location.pathname === MAIN_ROUTE;
                            // Отладочный вывод для "Главной"
                        } else {
                            // Логика для других элементов типа 'link' (например, "Жилье")
                            // Здесь мы делаем специальную обработку для "Жилья", как обсуждали
                            if (item.label === 'Жилье') {
                                // "Жилье" активно, если путь начинается с ADD_ROUTE (/add)
                                // ИЛИ если текущий путь ТОЧНО равен SHOP_ROUTE (/)
                                isActiveItem = location.pathname.startsWith(item.route) || location.pathname === SHOP_ROUTE;
                                // Подробный отладочный вывод для "Жилья"
                            } else {
                                // Для всех других элементов типа 'link' (если будут)
                                isActiveItem = location.pathname.startsWith(item.route);
                            }
                        }
                    } else if (item.type === 'button') {
                        // Логика активности для элементов типа 'button' (Исследовать, Профиль, Избранное)
                        if (item.label === 'Исследовать') {
                            // "Исследовать" активно, если меню открыто ИЛИ если текущий путь начинается
                            // с маршрутов, связанных с "Исследовать"
                            isActiveItem = showExploreMenu ||
                                location.pathname.startsWith(PLACES_ROUTE) ||
                                location.pathname.startsWith(BLOG_ROUTE) ||
                                location.pathname.startsWith(ABOUT_US_ROUTE) ||
                                location.pathname.startsWith(PHOTO_GALLERY_ROUTE);
                            // Отладочный вывод
                        } else if (item.label === 'Профиль') {
                            // "Профиль" активен, если пользователь авторизован И текущий путь начинается
                            // с PROFILE_ROUTE и содержит ID пользователя
                            isActiveItem = user.isAuth && location.pathname.startsWith(PROFILE_ROUTE) && user.UserData?.id && location.pathname.includes(`${PROFILE_ROUTE}/${user.UserData.id}`);
                            // Отладочный вывод
                        } else if (item.label === 'Избранное') {
                            // "Избранное" активно, если текущий путь начинается с FAVOURITES_ROUTE
                            isActiveItem = location.pathname.startsWith(FAVOURITES_ROUTE);
                            // Отладочный вывод
                        }
                    }

                    // Формируем финальный класс CSS для элемента, добавляя 'mobile-bottom-nav__item--active' при необходимости
                    // ИЗМЕНЕНО: ИСПОЛЬЗОВАНИЕ CSS-МОДУЛЕЙ
                    const itemClassName = `${styles.mobileBottomNavItem} ${isActiveItem ? styles.mobileBottomNavItemActive : ''}`;

                    // Рендеринг элемента: либо как <div> с обработчиком клика (для кнопок), либо как <NavLink> (для ссылок)
                    if (item.type === 'button') {
                        let onClickHandler;
                        if (item.label === 'Профиль') {
                            onClickHandler = handleProfileClick;
                        } else if (item.label === 'Избранное') {
                            onClickHandler = handleFavouritesClick;
                        } else if (item.label === 'Исследовать') {
                            onClickHandler = handleExploreClick;
                        }

                        return (
                            <div
                                key={index}
                                className={itemClassName} // <-- ИЗМЕНЕНО
                                onClick={onClickHandler} // Применяем соответствующий обработчик клика
                            >
                                <img
                                    src={iconSrc}
                                    alt={item.label}
                                    className={`${styles.mobileBottomNavIcon} ${item.label === 'Профиль' ? styles.mobileBottomNavIconProfile : ''}`}
                                />
                                <span
                                    className={styles.mobileBottomNavLabel}
                                >
                                    {item.label}
                                </span> {/* <-- ИЗМЕНЕНО */}
                            </div>
                        );
                    } else { // item.type === 'link'
                        return (
                            <NavLink
                                key={index}
                                to={item.route}
                                className={itemClassName} // <-- ИЗМЕНЕНО
                                onClick={() => {
                                    // При переходе по ссылке закрываем меню "Исследовать", если оно было открыто
                                    handleCloseExploreMenu();
                                }}
                            >
                                <img
                                    src={iconSrc}
                                    alt={item.label}
                                    className={styles.mobileBottomNavIcon} // <-- ИЗМЕНЕНО
                                />
                                <span
                                    className={styles.mobileBottomNavLabel}
                                >
                                    {item.label}
                                </span> {/* <-- ИЗМЕНЕНО */}
                            </NavLink>
                        );
                    }
                })}
            </nav>

            <RegistrationForm show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)} />

            <ExploreMenu show={showExploreMenu} onClose={handleCloseExploreMenu} />
        </>
    );
});

export default MobileBottomNav;